<script>
export default {
    name: 'Top',
    data() {
        return {

        }
    }
}
</script>
<template>
    <div class="bg-white">
        <div class="mx-auto max-w-4xl px-3 flex text-gray-600 leading-none align-middle p-2">
            <div class="w-9/12 overflow-hidden flex align-middle justify-end text-right items-center">
                <span class="font-bold text-sm ml-3">PAGAMENTO 100% SEGURO</span>
            </div>
        </div>
    </div>
</template>
